import { BrowserRouter as Router } from "react-router-dom";
import { Container } from "react-bootstrap";
import "./styles/App.min.css";

import { Header, Footer, SubNavbar } from "./components/Layout";
import AppRouter from "./utilities/AppRouter";
import DarknetProvider from "./providers/DarknetProvider";
import SolanaProvider from "./providers/SolanaProvider";
import GlobalChatWidget from "./components/widgets/GlobalChatWidget";

import * as buffer from "buffer";
window.Buffer = buffer.Buffer;

const App = () => {
  return (
    <Router>
      <SolanaProvider>
        <DarknetProvider>
          <Header />
          <Container fluid className='g-0' data-bs-theme="dark">
            <SubNavbar />
            <div className="content mx-0 mx-md-5 mt-5 mt-md-0">
              <AppRouter />
            </div>
          </Container>
          <Footer />
          <GlobalChatWidget />
        </DarknetProvider>
      </SolanaProvider>
    </Router>
  );
}

export default App;
